// react-dom/server is imported lazily so it stays out of the client bundle.
import { StaticRouter } from "react-router-dom/server";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Toaster as Sonner } from "@/components/ui/sonner";
import Index from "./pages/Index.tsx";
import NotFound from "./pages/NotFound.tsx";
import ResourcesIndex from "./pages/ResourcesIndex.tsx";
import ResourceArticlePage from "./pages/ResourceArticlePage.tsx";
import ProductPage from "./pages/ProductPage.tsx";
import { Route, Routes } from "react-router-dom";
import { SITE_URL, ogImageFor, seoForPath } from "./lib/seo";
import "./index.css";

export async function prerender(data: { url: string }) {
  const queryClient = new QueryClient();
  const { renderToString } = await import("react-dom/server");
  const html = renderToString(
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Sonner />
        <StaticRouter location={data.url}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/products/:slug" element={<ProductPage />} />
          <Route path="/resources" element={<ResourcesIndex />} />
          <Route path="/resources/:slug" element={<ResourceArticlePage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </StaticRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
  const seo = seoForPath(data.url);
  const url = SITE_URL + seo.path;
  return {
    html,
    head: {
      lang: "en",
      title: seo.title,
      elements: new Set([
        { type: "meta", props: { "http-equiv": "Content-Security-Policy", content: "default-src 'self'; script-src 'self' https://cloud.umami.is; style-src 'self' 'unsafe-inline'; img-src 'self' data: https:; font-src 'self'; media-src 'self'; connect-src 'self' https://cloud.umami.is https://api-gateway.umami.dev https://gateway.umami.is; frame-src https://www.google.com; object-src 'none'; base-uri 'self'; form-action 'self'; upgrade-insecure-requests" } },
        { type: "meta", props: { name: "description", content: seo.description } },
        { type: "link", props: { rel: "canonical", href: url } },
        { type: "meta", props: { property: "og:title", content: seo.title } },
        { type: "meta", props: { property: "og:description", content: seo.description } },
        { type: "meta", props: { property: "og:url", content: url } },
        { type: "meta", props: { property: "og:image", content: ogImageFor(seo) } },
        { type: "meta", props: { name: "twitter:image", content: ogImageFor(seo) } },
      ]),
    },
  };
}
